import React from 'react';

const Dashboard = () => {
  return (
    <div className="dashboard-page">
      <div className="dashboard-stats">
        <div className="dashboard-stat-card">
          <div className="dashboard-stat-icon">📝</div>
          <div className="dashboard-stat-content">
            <div className="dashboard-stat-value">5</div>
            <div className="dashboard-stat-label">Applications</div>
          </div>
        </div>
        <div className="dashboard-stat-card">
          <div className="dashboard-stat-icon">✅</div>
          <div className="dashboard-stat-content">
            <div className="dashboard-stat-value">2</div>
            <div className="dashboard-stat-label">Approved</div>
          </div>
        </div>
        <div className="dashboard-stat-card">
          <div className="dashboard-stat-icon">⏳</div>
          <div className="dashboard-stat-content">
            <div className="dashboard-stat-value">3</div>
            <div className="dashboard-stat-label">Pending</div>
          </div>
        </div>
        <div className="dashboard-stat-card">
          <div className="dashboard-stat-icon">📋</div>
          <div className="dashboard-stat-content">
            <div className="dashboard-stat-value">1</div>
            <div className="dashboard-stat-label">Screening</div>
          </div>
        </div>
      </div>
      <div className="dashboard-content">
        <div className="dashboard-section">
          <h2 className="dashboard-section-title">Your Applications</h2>
          <p>Your rental applications will appear here.</p>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
